'use client';

import { useEffect, useRef } from 'react';
import { usePathname } from 'next/navigation';
import { useCart } from '../commerce/cart/cart-context';
import elevarItemView from '@/lib/elevar/item-view';
import { elevarBaseData } from '@/lib/elevar/cart-events';
import { useSelectedVariant } from '../product/product-context';

export default function ElevarProduct({
  slug,
  isBundlePage,
  productData,
  bundleData
}) {
  const { cart, cartReady } = useCart();
  const { variant } = useSelectedVariant();
  const pathname = usePathname();
  const lastFiredPath = useRef(null);

  useEffect(() => {
    if (!cartReady || lastFiredPath.current === pathname) return;
    lastFiredPath.current = pathname;
    (async () => {
      if (window.ElevarDataLayer?.length > 1) {
        await window.ElevarInvalidateContext?.();
      }
      await elevarBaseData(cart);
      elevarItemView(isBundlePage, productData, bundleData, variant);
    })();
  }, [
    cartReady,
    cart,
    pathname,
    slug,
    productData,
    isBundlePage,
    bundleData,
    variant
  ]);

  useEffect(() => {
    return () => {
      lastFiredPath.current = null;
    };
  }, [pathname]);

  return null;
}
